import React from 'react';
import { Route } from 'react-router-dom';
import AdminIndexRoutes from './adminIndex';

const Routes = [
  <Route key="admin/*" path="admin/*" element={<AdminIndexRoutes />} />,
];

export default Routes;
